import axios from 'axios'

export const getTokenConfig = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_TOKEN_URL, //<= base url
})
